import WordCloudBox from './WordCloudBox';
import './WordCloudBox.scss';

export default WordCloudBox;
